import React from "react"
import tw from "twin.macro"

import { useMenuContext } from "./Menu"

export interface MenuItemProps {
  onClick?: (event: React.MouseEvent) => void
  [x: string]: any
}

const MenuItem: React.FC<MenuItemProps> = ({ children, onClick, ...props }) => {
  const { onClose } = useMenuContext()

  const handleClick = (event: React.MouseEvent) => {
    if (onClick) {
      onClick(event)
    }

    onClose()
  }

  return (
    <Item onClick={handleClick} {...props}>
      {children}
    </Item>
  )
}

const Item = tw.li`block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out cursor-pointer hover:bg-gray-100 focus:outline-none focus:bg-gray-100`

export default MenuItem
